import { useState } from 'react';
import App from './App';
import Studio from './components/Studio';

/**
 * L'éditeur « prise unique » (modes Troubadour / Maestro) est l'écran
 * principal : simple, pour ceux qui découvrent. Le Studio multipiste
 * (timeline) est la plus-value, accessible par le bouton « Studio ▸ ».
 */
export default function Root() {
  const [studio, setStudio] = useState<boolean>(() => {
    try {
      return localStorage.getItem('quantime.studio') === '1';
    } catch {
      return false;
    }
  });

  const go = (v: boolean) => {
    try {
      localStorage.setItem('quantime.studio', v ? '1' : '0');
    } catch {
      /* mode privé */
    }
    setStudio(v);
  };

  return studio ? <Studio onExit={() => go(false)} /> : <App onOpenStudio={() => go(true)} />;
}
